<template>
  <CDropdown :title :icon :theme class="c-link-job-dropdown">
    <CButton v-for="job in targets" :key="job.id" @click="link(job)">
      <CJob :job/>
    </CButton>
    <CButton theme="normal-primary" @click="link(null)">
      <CIcon name="link-broken"/>
      {{ $t('repairOrderModal.unassigned') }}
    </CButton>
  </CDropdown>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import Modal from '@/general/utils/Modal';
  import CIcon from '@/shared/components/CIcon.vue';
  import CButton from '@/shared/components/buttons/CButton.vue';
  import CDropdown from '@/shared/components/dropdown/CDropdown.vue';
  import Job from '../../models/Job';
  import JobContext from '../../models/JobContext';
  import JobItem from '../../models/JobItem';
  import JobItemService from '../../services/JobItemService';
  import CJob from '../CJob.vue';

  const JobLinkConfirmationModal = () => import('../../modals/JobLinkConfirmationModal.vue');

  const props = defineProps<{
    source: Job | JobItem,
    targets: Array<Job>,
    context: JobContext,
  }>();

  const title = computed(() => {
    if (props.source instanceof Job) return `${props.source.sequenceNumber}.`;
    else if (props.source.jobId) return `${props.context.getJobById(props.source.jobId)?.sequenceNumber}.`;
  });

  const icon = computed(() => {
    if (props.source instanceof JobItem && !props.source.jobId) return 'minus-double';
  });

  const theme = computed(() => {
    return props.source instanceof JobItem && props.source.isRecent ? 'main-primary' : 'normal-secondary';
  });

  async function link(target: Job | null) {
    if (props.source instanceof Job) {
      const keepSource = await Modal.openAndWait(JobLinkConfirmationModal);
      await JobItemService.linkAllFromJob(props.source, target, keepSource, props.context);
    } else {
      await JobItemService.link(props.source, target, props.context);
    }
  }
</script>

<style lang="scss">
  .c-link-job-dropdown {
    .c-dropdown-panel {
      max-width: 40rem;
      white-space: pre-wrap;
    }
  }
</style>
